module.exports = __webpack_public_path__ + "img/CALENDER.d168d730.svg";